import { useMutation, useQuery, useQueryClient } from "react-query";
import { axiosGet, axiosPut, reactQueryDefaultOptions } from "../helpers/baseApi";
import { SERVICE_URLS } from "../helpers/serviceUrls";
import { QUERY_KEYS } from "../helpers/queryKeys";

// Portal settings an admin edits from Setup. Global, not per OE period.

// Shown while the message loads or if the request fails, so a blocked client
// never sees an empty page. Keep in sync with PortalSettingKeys.DefaultBlockedMessage
// on the server.
export const DEFAULT_BLOCKED_MESSAGE =
  "The portal will be closed until Nov 1, 2026 as we prepare for the new plan year. Please reach out to your Benefit Specialist if you need assistance during this time.";

export const BLOCKED_MESSAGE_MAX_LENGTH = 1000;

export const useQueryGetBlockedMessage = (enabled = true) => {
  const getData = async () => {
    return await axiosGet(SERVICE_URLS.PORTAL_SETTING_BLOCKED_MESSAGE);
  };

  return useQuery([QUERY_KEYS.PORTAL_SETTING_BLOCKED_MESSAGE], getData, {
    ...reactQueryDefaultOptions,
    enabled,
  });
};

export const useMutateSaveBlockedMessage = () => {
  const queryClient = useQueryClient();

  const saveData = async (message) => {
    return await axiosPut(SERVICE_URLS.PORTAL_SETTING_BLOCKED_MESSAGE, {
      message,
    });
  };

  return useMutation(saveData, {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.PORTAL_SETTING_BLOCKED_MESSAGE]);
    },
  });
};
